window.MITO = window.MITO || {};

$(document).ready(function () {
  var $mobileMenu = $('.mobile-menu');
  var $mobileMenuToggle = $('.mobile-menu__button');
  var mobileMenuActiveClass = 'mobile-menu--active';
  var $newsletterForm = $('#Form_NewsletterForm');
  var $newsletterSignupButton = $('#newsletterSignupButton');
  var $pageBody = $('body');
  var $selectElement = $('#Form_IndustyFilterForm select');

  const externalLinksMadeByTinyMCE = $('.typography .content__container a[href^="https:"]');
  externalLinksMadeByTinyMCE.each(function(index, el) {
    el.setAttribute(
      'class',
      el.getAttribute('class') ? el.getAttribute('class') + ' external' : 'external');
    el.setAttribute(
      'rel',
      el.getAttribute('rel') ? el.getAttribute('rel') + ' external' : 'external');
  });

  if ($selectElement.length > 0) {
    $selectElement.select2();
  }

  // send data to GTM (step 1) when newsletter button clicked
  $newsletterSignupButton.on('click', function (event) {
    dataLayer.push({
      event: 'newsletter',
      step: 1
    });
  });

  $newsletterForm.on('submit', function (event) {

    var self = $(this);
    event.preventDefault();

    // convert form data into key-value pairs
    var formData = $newsletterForm.serializeArray().reduce(function(obj, item) {
      obj[item.name] = item.value;
      return obj;
    }, {});

    // get email data
    var email = formData.Email;
    var emailPrefix = email.substring(0, email.lastIndexOf("@"));
    var emailDomain = email.substring(email.lastIndexOf("@") +1);

    // encrypt the email address with SHA-256
    // the cryptoJS library is loaded in Page.php
    // see: https://cryptojs.gitbook.io/docs/
    var emailHashWordArray = CryptoJS.SHA256(email);
    var emailHash = emailHashWordArray.toString(CryptoJS.enc.Base64);

    // send data to GTM (step 2) when newsletter signup submitted
    dataLayer.push({
      event: 'newsletter',
      step: 2,
      emailPrefix: emailPrefix,
      emailDomain: emailDomain,
      emailHash: emailHash
    });

    $('#NewsletterModal').find('button.action').attr('disabled', 'disabled');
    $('#NewsletterModal').find('button.action').html('Sending...');

    // POST form data
    $.post(
      self.attr('action'),  // uri: /home/NewsletterForm/
      self.serialize(),     // stringify the form data
      function (result) {
        $('#NewsletterModal').find('.modal-body').html(result); // if successful, display success message
      }
    );
  });

  $('.videomodal').on('hidden.bs.modal', function (e) {
    $(this).find('iframe').attr('src', $(this).find('iframe').attr('src'));
  });

  $mobileMenuToggle.on('click', function (event) {
    event.preventDefault();
    $mobileMenu.toggleClass('mobile-menu--active');
    $pageBody.toggleClass('body-no-scroll'); // don't scroll body when mobile menu open

    // Code to fix menu on small iPhone screen
    if (( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) &&
      screen.height < 700 &&
      $mobileMenu.hasClass('mobile-menu--active'))
    {
      $mobileMenu.toggleClass('mobile-menu--low-height');
    }
  });

  // prevent this script from crashing on campaigns signup page
  if (typeof enquire !== 'undefined') {
    enquire.register(window.MITO.CONSTANTS.BREAKPOINT.INCREASES_TO.MD, {
      match: function () {
        // Collapse the main navigation.
        $mobileMenu
          .removeClass(mobileMenuActiveClass);
      },
    });
  }
});

// Popup
$(document).ready(function () {
  $('.js-close-pop-up').click(function (e) {
    $(this).closest('.js-pop-up').hide();
  });
});

// Industry Dropdown
$(document).ready(function () {
  var $industryDropdown = $('select.js-industry');
  var $rolesDropdown = $('select.js-job-roles');

  function populateJobRoles(complete) {
    var id = $industryDropdown.find('option:selected').attr('value');
    var baseUrl = $industryDropdown.data('url');
    var url = baseUrl + '?id=' + id;

    var currRoles = $rolesDropdown.val()
    $.ajax(url)
      .done(function (response) {
        $rolesDropdown.val(null);
        $rolesDropdown.html(response);
        $rolesDropdown.prepend('<option value="" selected>Please select</option>');
        $rolesDropdown.prop('disabled', false).trigger('change');
        $rolesDropdown.val(currRoles).trigger('change');

        // This is required for the registration form (not the profile form)
        $rolesDropdown.prop('disabled', false);

        if (complete) complete();
      })
      .fail(function (error) {
        console.log('error: ', error);
      });
  }

  if ($rolesDropdown.length) {
    if ($industryDropdown.val()) {
      populateJobRoles(function() {
      });
    } else {
      $rolesDropdown.empty();
      $rolesDropdown.prop('disabled', true);
      $rolesDropdown.append('<option value="" selected>Please select</option>');
    }
  }

  if ($industryDropdown.length) {
    $industryDropdown.on('change', function() {
      populateJobRoles()
    });
  }
});

// Locations/regions Dropdown
$(document).ready(function () {
  var secondPreviousWork = $('.previous-work-group2');
  var thirdPreviousWork = $('.previous-work-group3');

  $('input[name="action_AddAnother"]').on('click', function(e) {
    e.preventDefault();

    if (!secondPreviousWork.hasClass('show')) {

      $('input[name="action_close2"]').on('click', function() {
        e.preventDefault();
        secondPreviousWork.removeClass('show');
        $('input[name="action_AddAnother"]').show();
      });

      secondPreviousWork.addClass('show');
    } else if (!thirdPreviousWork.hasClass('show')) {

      $('input[name="action_close3"]').on('click', function() {
        e.preventDefault();
        thirdPreviousWork.removeClass('show');
        $('input[name="action_AddAnother"]').show();
      });

      thirdPreviousWork.addClass('show');
      $(this).hide();
    }
  });

  var $regionDropdown = $('select.js-regions');
  var $locationDropdown = $('select.js-locations');

  function populateLocations(complete) {
    var regions = $regionDropdown.val();
    var url = $regionDropdown.data('url');
    var currLocations = $locationDropdown.val();

    // This is required for the registration form (not the profile form)
    $locationDropdown.prop('disabled', false);
    $locationDropdown.select2({
      maximumSelectionSize: 3
    });

    $.ajax({
      'method': 'GET',
      'url': url,
      'data': {
        'regions' : regions
      }
    })
      .done(function (response) {
        $locationDropdown.val(null);
        $locationDropdown.html(response);
        $locationDropdown.prop('disabled', false).trigger('change');

        $locationDropdown.val(currLocations).trigger('change');

        if (complete) complete();
      })
      .fail(function (error) {
        console.log('error: ', error);
      });
  }

  if ($locationDropdown.length > 0) {
    if ($regionDropdown.val() && $regionDropdown.val().length > 0) {
      populateLocations();
    } else {
      $locationDropdown.empty();
      $locationDropdown.prop('disabled', true);
    }
  }

  if ($regionDropdown.length > 0) {
    $regionDropdown.on('change', function() {
      populateLocations()
    });
  }
});

// browser handling
$(document).ready(function () {
  jQuery.browser = {};
  jQuery.browser.msie = false;
  jQuery.browser.version = 0;
  if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
    jQuery.browser.msie = true;
    jQuery.browser.version = RegExp.$1;
  }
});

// Handing the display logic fields in jobseeker form
$(function () {
  var CompletedQualificationField = $('input[name="CompletedQualification"]');
  var QualificationDetailFieldHolder = $('#Form_RegisterForm_QualificationDetails_Holder');
  var HappytoMoveField = $('input[name="HappytoMove"]');
  var LocationRegionFieldHolder = $('#Form_RegisterForm_RegionMoveTo_Holder, #Form_ProfileForm_RegionMoveTo_Holder');

  var vehicleTypesField = $('input[name="OtherLicense"]');
  var vehicleTypes = $('select.js-vehicle-types');
  var otherLicenseFieldHolder = $('#Form_RegisterForm_OtherLicense_Holder, #Form_ProfileForm_OtherLicense_Holder');

  if (vehicleTypes.val().includes("Other (i.e. forklift)")) {
    otherLicenseFieldHolder.show();
  } else {
    otherLicenseFieldHolder.hide();
  }

  $(document).on('change', vehicleTypesField, function() {
    if (vehicleTypes.val().includes("Other (i.e. forklift)")) {
      otherLicenseFieldHolder.show();
    } else {
      otherLicenseFieldHolder.hide();
    }
  });

  if (HappytoMoveField && LocationRegionFieldHolder) {

    // don't assume checkbox is unchecked when page loads
    if (HappytoMoveField.is(":checked")) {
      LocationRegionFieldHolder.show();
    } else {
      LocationRegionFieldHolder.hide();
    }

    // only display the LocationRegionFieldHolder if HappytoMoveField is checked
    $(document).on('change', HappytoMoveField, function() {
      if (HappytoMoveField.is(":checked")) {
        LocationRegionFieldHolder.show();
      } else {
        LocationRegionFieldHolder.hide();
      }
    });
  }

  if (CompletedQualificationField && QualificationDetailFieldHolder) {

    // don't assume checkbox is unchecked when page loads
    if (CompletedQualificationField.is(":checked")) {
      QualificationDetailFieldHolder.show();
    } else {
      QualificationDetailFieldHolder.hide();
    }

    // only display the QualificationDetailField is  CompletedQualification is checked
    $(document).on('change', CompletedQualificationField, function() {
      if (CompletedQualificationField.is(":checked")) {
        QualificationDetailFieldHolder.show();
      } else {
        QualificationDetailFieldHolder.hide();
      }
    });
  }
});
